import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AnalyticsReportsCacheStore {
  cache: Record<string, any>
  hydrated: boolean
  setCache: (key: string, data: any) => void
  getCache: (key: string) => any
  setHydrated: (value: boolean) => void
  clear: () => void
}

export const useAnalyticsReportsCacheStore = create<AnalyticsReportsCacheStore>()(
  persist(
    (set, get) => ({
      cache: {},
      hydrated: false,
      setCache: (key, data) => {
        set(state => ({
          cache: { ...state.cache, [key]: data }
        }))
      },
      getCache: key => {
        const value = get().cache[key]
        return value
      },
      setHydrated: value => set({ hydrated: value }),
      clear: () => set({ cache: {}, hydrated: false })
    }),
    {
      name: 'analytics-reports-cache',
      onRehydrateStorage: () => () => {
        useAnalyticsReportsCacheStore.getState().setHydrated(true)
      }
    }
  )
)